import { createContext, useContext, useState, useCallback } from "react";
import LeadQualifierModal from "@/components/shared/LeadQualifierModal";

const LeadCtx = createContext({ open: () => {} });
export const useLeadModal = () => useContext(LeadCtx);

export default function LeadProvider({ children }) {
  const [open, setOpen] = useState(false);
  // Optional per-medication context (slug, name, assessment image) — drives the modal hero strip
  // so the assessment visually changes per medication.
  const [ctx, setCtx] = useState(null);

  const openModal = useCallback((nextCtx) => {
    setCtx(nextCtx && typeof nextCtx === "object" ? nextCtx : null);
    setOpen(true);
  }, []);

  // Intercept clicks on any element with href targeting assessment / start-assessment
  const onClickCapture = useCallback((e) => {
    const a = e.target.closest("a,button");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const testid = a.getAttribute("data-testid") || "";
    const isAssessment =
      href.includes("start-assessment") ||
      testid.includes("start-assessment") ||
      testid.includes("cta-start") ||
      testid.includes("cta-assessment") ||
      /start your (assessment|journey)/i.test(a.textContent || "");
    if (isAssessment) {
      e.preventDefault();
      e.stopPropagation();
      setCtx(null);
      setOpen(true);
    }
  }, []);

  return (
    <LeadCtx.Provider value={{ open: openModal }}>
      <div onClickCapture={onClickCapture}>{children}</div>
      <LeadQualifierModal open={open} onClose={() => setOpen(false)} context={ctx} />
    </LeadCtx.Provider>
  );
}
